import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataDocumentExtraction } from '@onefootprint/request-types/dashboard';
import type { NodeProps } from '@/playbook-builder/playbook-builder.types';
import BaseNode from '../base-node';
import DocumentExtractionForm from './components/document-extraction-form';
type DocumentExtractionNodeProps = NodeProps<ApiNodeDataDocumentExtraction> & {
  onSubmit?: (data: ApiNodeDataDocumentExtraction) => void; // For storybook testing
};
const DocumentExtractionNode = t0 => {
  const $ = _c(11);
  let node;
  let onSubmit;
  if ($[0] !== t0) {
    ({
      onSubmit,
      ...node
    } = t0);
    $[0] = t0;
    $[1] = node;
    $[2] = onSubmit;
  } else {
    node = $[1];
    onSubmit = $[2];
  }
  let t1;
  if ($[3] !== node.data || $[4] !== node.id || $[5] !== onSubmit) {
    t1 = {
      size: "lg",
      render: t2 => {
        const {
          mutation,
          canEdit
        } = t2;
        return <DocumentExtractionForm mutation={mutation} nodeData={node.data} nodeId={node.id} canEdit={canEdit} onSubmit={onSubmit} />;
      },
      form: "document-review-form"
    };
    $[3] = node.data;
    $[4] = node.id;
    $[5] = onSubmit;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== node.data || $[8] !== node.id || $[9] !== t1) {
    t2 = <BaseNode nodeId={node.id} data={node.data} sidebar={t1} />;
    $[7] = node.data;
    $[8] = node.id;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
export default DocumentExtractionNode;